import { render, staticRenderFns } from "./Taproom.vue?vue&type=template&id=46a59392&scoped=true&lang=html&"
import script from "./Taproom.vue?vue&type=script&lang=js&"
export * from "./Taproom.vue?vue&type=script&lang=js&"
import style0 from "./Taproom.vue?vue&type=style&index=0&id=46a59392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a59392",
  null
  
)

export default component.exports